import APIClient from "../../../common/APIClient";
import {
  toggleShowAlert,
  displayError,
  SUCCESS_ALERT,
  MAX_ITEMS_IN_PAGE,
} from "../commonActions";
import { formatDate } from "../../../common/Utilities";
import { fetchProjects } from "../projects/projectsActions";
import { Cache } from "aws-amplify";
import moment from "moment";
import qs from "qs";

const TIMESHEET_SET_FIELD_VALUE = "TIMESHEET_SET_FIELD_VALUE";
const ADD_ADDITIONAL_TIMESHEET_ENTRY = "ADD_ADDITIONAL_TIMESHEET_ENTRY";
const FETCH_TIMESHEETS = "FETCH_TIMESHEETS";
const SET_SELECTED_WEEK = "SET_SELECTED_WEEK";
const ADD_DATES = "ADD_DATES";
const RESET_TIMESHEET_ENTRIES = "RESET_TIMESHEET_ENTRIES";
const ADD_TIMESHEET_ENTRY = "ADD_TIMESHEET_ENTRY";
const ADD_ROW_NUM = "ADD_ROW_NUM";
const DECREASE_NUM_ROW = "DECREASE_NUM_ROW";
const ADD_TIMESHEET_ENTRY_DATE = "ADD_TIMESHEET_ENTRY_DATE";
const UPDATE_TIMESHEET_DURATIONS = "UPDATE_TIMESHEET_DURATIONS";
const UPDATE_ADDITIONAL_TIMESHEET_ENTRIES =
  "UPDATE_ADDITIONAL_TIMESHEET_ENTRIES";
const CLEAR_TIMESHEET_ENTRIES = "CLEAR_TIMESHEET_ENTRIES";
const UPDATE_TIMESHEET_ENTRIES = "UPDATE_TIMESHEET_ENTRIES";
const SET_ROW_NUM = "SET_ROW_NUM";
const SET_TIMESHEET = "SET_TIMESHEET";
const RESET_TIMESHEET = "RESET_TIMESHEET";
const ADD_TIMESHEET_REMARKS = "ADD_TIMESHEET_REMARKS";
const ADD_ENTRY_TO_DELETE = "ADD_ENTRY_TO_DELETE";
const SET_MONTHLY_ENTRIES = "SET_MONTHLY_ENTRIES";
const RESET_MONTHLY_ENTRIES = "RESET_MONTHLY_ENTRIES";
const SHOW_TIMESHEET_LOADER = "SHOW_TIMESHEET_LOADER";
const CLEAR_ENTRY_TO_DELETE = "CLEAR_ENTRY_TO_DELETE";
const GET_ENTRIES_BY_PROJECT_ID = "GET_ENTRIES_BY_PROJECT_ID";
const ADD_OVERTIME_ENTRIES = "ADD_OVERTIME_ENTRIES";
const SET_OVERTIME_ENTRIES = "SET_OVERTIME_ENTRIES";
const GET_TIME_ENTRIES_PER_PROJECT = "GET_TIME_ENTRIES_PER_PROJECT";
const RESET_TIME_ENTRIES_PER_PROJECT = "RESET_TIME_ENTRIES_PER_PROJECT";
const GET_APPROVED_TIME_ENTRIES = "GET_APPROVED_TIME_ENTRIES";
const CLEAR_APPROVED_TIME_ENTRIES = "CLEAR_APPROVED_TIME_ENTRIES";

export const PENDING = "Pending Approval";
export const APPROVED = "Approved";
export const DRAFT = "Draft";
export const NEW = "New";
export const REJECTED = "Rejected";
export const REGULAR = "Regular";
export const OVERTIME = "Overtime";

export const HAS_REQUIRED_HOURS = "has-required-hours";
export const BELOW_REQUIRED_HOURS = "below-required-hours";
export const OVER_REQUIRED_HOURS = "over-required-hours";
export const OVER_WEEKEND_HOURS = "over-weekend-hours";
export const FUTURE_DATE = "future-date";
export const WORK_HOURS = 8;
export const WORK_DAYS = 5;

export const SET_TIMESHEET_PAGINATION = "SET_TIMESHEET_PAGINATION";
export const RESET_TIMESHEET_PAGINATION = "RESET_TIMESHEET_PAGINATION";

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};

export const upsertTimesheet = (action, successCallback = null) => {
  return (dispatch, getState) => {
    const timesheet = getState().timesheets.timesheets;

    //if start date is undefined, it is automatically set as current date from the from
    if (typeof timesheet.start_date === "undefined") {
      Object.assign(timesheet, { start_date: new Date() });
    } else {
      Object.assign(timesheet, { start_date: new Date(timesheet.start_date) });
    }
    //if end date is undefined, it is automatically set as current date from the from
    if (typeof timesheet.end_date === "undefined") {
      Object.assign(timesheet, { end_date: new Date() });
    } else {
      Object.assign(timesheet, { end_date: new Date(timesheet.end_date) });
    }

    //format date before sending to endpoint
    Object.assign(timesheet, { start_date: formatDate(timesheet.start_date) });
    Object.assign(timesheet, { end_date: formatDate(timesheet.end_date) });
  };
};

export const fetchTimesheets = () => {
  return (dispatch, getState) => {
    const userId = Cache.getItem("userId");
    client()
      .get("/timesheet/my-timesheet", {
        params: {
          user_id: userId,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let timesheet = result.data;
          if (!timesheet.length) {
            timesheet = null;
          } else {
            let numItems = timesheet.length;
            let min = getState().timesheets.min;
            let max =
              numItems < MAX_ITEMS_IN_PAGE
                ? numItems
                : getState().timesheets.max;

            const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);

            dispatch({
              type: SET_TIMESHEET_PAGINATION,
              numItems,
              min,
              max,
              totalPages,
            });
          }
          dispatch({ type: FETCH_TIMESHEETS, timesheet });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const enterTimeEntries = (status, successCallback = null) => {
  return (dispatch, getState) => {
    const timesheets = getState().timesheets.timesheetEntries;
    const additionalTimesheets = getState().timesheets.additionalTimeEntries;
    const durations = getState().timesheets.durationEntries;
    const overtimeEnties = getState().timesheets.overTimeEntries;
    const currentUser = getState().users.currentUser;

    const allTimeSheets = [...timesheets, ...additionalTimesheets];

    let arrTimeEntries = [];
    allTimeSheets.forEach((timesheetRow) => {
      const entryId = timesheetRow.entry_id;

      durations
        .filter((data) => {
          if (entryId === data.entry_id) {
            return data;
          }
          return null;
        })
        .forEach((timeEntry) => {
          let otHours = 0;
          //check if entry is tagged as OT
          overtimeEnties
            .filter((data) => {
              if (
                data.entryDate === timeEntry.date &&
                data.entryId === timeEntry.entry_id
              ) {
                return data;
              }
              return null;
            })
            .forEach((oTEntry) => {
              if (typeof oTEntry.otHours !== "undefined") {
                otHours = oTEntry.otHours;
              }
            });

          arrTimeEntries.push({
            task_id: timesheetRow.task_id,
            project_id: timesheetRow.project_id,
            duration: timeEntry.duration,
            time_entry_date: timeEntry.date,
            remarks: timeEntry.remarks,
            overtime_hours: otHours,
            entry_row_id: entryId,
          });
        });
    });

    client()
      .post("timesheet/create", {
        request_for_id: getState().users.currentUser.id,
        start_date: getState().timesheets.selectedWeek.start,
        end_date: getState().timesheets.selectedWeek.end,
        week_number: getState().timesheets.selectedWeek.week_num,
        year: getState().timesheets.selectedWeek.year,
        status,
        approver_id: currentUser.supervisor_id,
        time_entries: arrTimeEntries,
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const timesheetId = result.data;

          if (status === PENDING) {
            dispatch(sendToApprovers(timesheetId, successCallback));
          } else if (successCallback) {
            dispatch(
              toggleShowAlert(true, SUCCESS_ALERT, "Timesheet saved as draft.")
            );
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const updateTimeEntries = (status = null, successCallback = null) => {
  return (dispatch, getState) => {
    const timesheet = getState().timesheets.timesheet;
    if (Object.keys(timesheet).length > 0) {
      const timesheetId = timesheet.timesheet_id;

      const timesheets = getState().timesheets.timesheetEntries;
      const additionalTimeEntries = getState().timesheets.additionalTimeEntries;
      const timeEntries = getState().timesheets.durationEntries;
      const overtimeEnties = getState().timesheets.overTimeEntries;

      const timesheetRows = [...timesheets, ...additionalTimeEntries];

      timesheetRows.forEach((timesheetRow) => {
        const entryId = timesheetRow.entry_id;
        const projectId = timesheetRow.project_id;
        const taskId = timesheetRow.task_id;

        let arrNewEntries = [];
        let arrExistingEntries = [];

        timeEntries
          .filter((data) => {
            if (data.entry_id === entryId) {
              return data;
            }
            return null;
          })
          .forEach((timeEntry) => {
            //check if entry is tagged as OT
            let otHours = 0;

            overtimeEnties
              .filter((data) => {
                if (
                  data.entryDate === timeEntry.date &&
                  data.entryId === timeEntry.entry_id
                ) {
                  return data;
                }
                return null;
              })
              .forEach((oTEntry) => {
                if (typeof oTEntry.otHours !== "undefined") {
                  otHours = oTEntry.otHours;
                }
              });

            //Update existing entries during update
            if (typeof timeEntry.time_entry_id !== "undefined") {
              arrExistingEntries.push({
                project_id: projectId,
                task_id: taskId,
                timesheet_id: timesheetId,
                id: timeEntry.time_entry_id,
                duration: timeEntry.duration,
                time_entry_date: timeEntry.date,
                remarks: timeEntry.remarks,
                overtime_hours: otHours,
                entry_row_id: timeEntry.entry_id,
              });
            }
            //Add new entries during Update Timesheet
            else {
              arrNewEntries.push({
                project_id: projectId,
                task_id: taskId,
                timesheet_id: timesheetId,
                duration: timeEntry.duration,
                time_entry_date: timeEntry.date,
                remarks: timeEntry.remarks,
                overtime_hours: otHours,
                entry_row_id: timeEntry.entry_id,
              });
            }
          });

        if (arrExistingEntries.length > 0) {
          client()
            .post("time-entries/batch/update", {
              time_entries: arrExistingEntries,
            })
            .then((json) => {
              const result = json.data;
              if (result) {
                console.log("Time entries has been updated.");
              }
            })
            .catch((error) => {
              dispatch(displayError(error));
            });
        }

        if (arrNewEntries.length > 0) {
          client()
            .post("time-entries/batch/create", {
              time_entries: arrNewEntries,
            })
            .then((json) => {
              const result = json.data;
              if (result) {
                console.log("Time entries has been entered.");
              }
            })
            .catch((error) => {
              dispatch(displayError(error));
            });
        }

        if (status === DRAFT) {
          dispatch(
            toggleShowAlert(true, SUCCESS_ALERT, "Timesheet saved as draft.")
          );
        }

        if (successCallback) {
          successCallback();
        }
      });
    }
  };
};

export const changeStatus = (status) => {
  return (dispatch, getState) => {
    const timesheet = getState().timesheets.timesheet;
    if (Object.keys(timesheet).length > 0) {
      const id = timesheet.timesheet_id;
      client()
        .post("timesheet/update/status", {
          id,
          status,
        })
        .then((json) => {
          const result = json.data;
          if (result) {
            if (status === PENDING) {
              dispatch(sendToApprovers(id));
            }
          }
        })
        .catch((error) => {
          dispatch(displayError(error));
        });
    }
  };
};

export const showTimesheetLoader = (show) => {
  return (dispatch) => {
    dispatch({ type: SHOW_TIMESHEET_LOADER, show });
  };
};

export const sendToApprovers = (timesheetId, successCallback) => {
  return (dispatch) => {
    client()
      .post("timesheet-approval/create", {
        timesheet_id: timesheetId,
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(
            toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "Timesheet has been sent to approvers."
            )
          );
          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const addRemarks = (e) => {
  return (dispatch) => {
    const remarks = {
      [e.target.id]: e.target.value,
    };

    dispatch({ type: ADD_TIMESHEET_REMARKS, remarks });
  };
};

export const handleFieldChange = (e, definedValue = null) => {
  return (dispatch) => {
    let value;
    if (e) {
      value = {
        [e.target.id]: e.target.value,
      };
    } else {
      value = definedValue;
    }

    dispatch({ type: TIMESHEET_SET_FIELD_VALUE, value });
  };
};

export const handleTimesheetChange = (
  e,
  entry_id,
  definedValue = null,
  formGroup
) => {
  return (dispatch) => {
    let id = "";
    let value = "";
    if (definedValue === null) {
      id = e.target.id;
      value = e.target.value;
    } else {
      id = definedValue.id;
      value = definedValue.value;
    }

    if (formGroup === "init") {
      dispatch({
        type: ADD_TIMESHEET_ENTRY,
        id,
        value,
        entry_id,
      });
    } else {
      dispatch({
        type: ADD_ADDITIONAL_TIMESHEET_ENTRY,
        id,
        value,
        entry_id,
      });
    }
  };
};

export const handleTimeEntryChange = (e, entry_id, checkTotalHours = null) => {
  return (dispatch, getState) => {
    const currentDurations = getState().timesheets.durationEntries;

    const id = e.target.id;
    const value = e.target.value;
    //update time entry
    let entryExist = false;
    if (currentDurations.length > 0) {
      let newDurations = [];
      newDurations = currentDurations.map((timeEntry) => {
        if (timeEntry.date === id && timeEntry.entry_id === entry_id) {
          timeEntry.duration = value;
          entryExist = true;
        }

        return timeEntry;
      });
      dispatch({ type: UPDATE_TIMESHEET_DURATIONS, newDurations });
    }

    if (!entryExist) {
      let entry = {
        date: id,
        duration: value,
        entry_id,
        remarks: "",
      };
      dispatch({ type: ADD_TIMESHEET_ENTRY_DATE, entry });
    }

    if (checkTotalHours) {
      checkTotalHours();
    }
  };
};

export const handleEntryRemarks = (remarks, date, entryId) => {
  return (dispatch, getState) => {
    let timeDurations = getState().timesheets.durationEntries;

    timeDurations =
      timeDurations.length &&
      timeDurations.map((timeDuration) => {
        if (
          timeDuration.date === date.shortHandDate &&
          timeDuration.entry_id === entryId
        ) {
          timeDuration.remarks = remarks;
        }

        return timeDuration;
      });

    dispatch({ type: UPDATE_TIMESHEET_DURATIONS, newDurations: timeDurations });
  };
};

export const setTimesheetDurations = (newDurations) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_TIMESHEET_DURATIONS, newDurations });
  };
};

export const getProjectFromList = (entryId, projectId, formGroup) => {
  return (dispatch, getState) => {
    const projects = getState().projects.projects;

    projects
      .filter((data) => {
        if (parseInt(projectId) === data.id) {
          return data;
        }
        return null;
      })
      .forEach((project) => {
        dispatch(
          handleTimesheetChange(
            null,
            entryId,
            {
              id: "project",
              value: project,
            },
            formGroup
          )
        );
      });
  };
};

export const addRow = () => {
  return (dispatch, getState) => {
    const entries = getState().timesheets.additionalTimeEntries;

    const numItems = getState().timesheets.numRows;
    if (entries.length > 0) {
      entries.forEach((timesheetDate) => {
        let entry = {
          date: timesheetDate.shortHandDate,
          duration: 0,
          remarks: "",
          overtime_hours: 0,
          entry_id: parseInt(numItems) + 1,
        };
        dispatch({
          type: ADD_TIMESHEET_ENTRY_DATE,
          entry,
        });
      });
    }
    dispatch({ type: ADD_ROW_NUM });
  };
};

export const selectWeek = (date) => {
  return (dispatch) => {
    dispatch(resetTimesheetDates());

    var week = moment(date).isoWeek();
    var month = moment(date).month();
    var year = moment(date).year();
    let startDate = moment(date).startOf("isoWeek").toString();
    let endDate = moment(date).endOf("isoWeek").toString();

    startDate = formatDate(new Date(startDate));
    endDate = formatDate(new Date(endDate));

    const selectedWeek = {
      start: startDate,
      end: endDate,
      week_num: week,
      year: year,
      month: month,
      total_duration: 0,
      total_tasks: 0,
    };

    dispatch({ type: SET_SELECTED_WEEK, week: selectedWeek });
  };
};

export const generateDateRange = () => {
  return (dispatch, getState) => {
    const selectedWeek = getState().timesheets.selectedWeek;
    let startDate = "";
    let endDate = "";

    if (Object.keys(selectedWeek).length > 0) {
      startDate = selectedWeek.start;
      endDate = selectedWeek.end;

      startDate = new Date(startDate);
      endDate = new Date(endDate);

      var loop = new Date(startDate);

      while (loop <= endDate) {
        dispatch(addTimesheetDate(loop, 1, true));
        var newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
      }
    }
  };
};

export const addTimesheetDate = (date, entryId, isUpdate = false) => {
  return (dispatch, getState) => {
    const timesheetDates = getState().timesheets.timesheetDates;
    if (timesheetDates.length < 7) {
      var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const value = {
        actualDate: date,
        shortHandDate: formatDate(date, "-"),
        month: date.getMonth() + 1,
        numDate: date.getDate(),
        day: days[date.getDay()],
        entries: [
          {
            entry_id: 1,
          },
        ],
      };

      dispatch({ type: ADD_DATES, value });

      if (!isUpdate) {
        let entry = {
          date: formatDate(date, "-"),
          duration: 0,
          entry_id: entryId,
          remarks: "",
          overtime_hours: 0,
          addingRemarks: false,
        };
        dispatch({ type: ADD_TIMESHEET_ENTRY_DATE, entry });
      }
    }
  };
};

export const clearTimesheetEntries = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_TIMESHEET_ENTRIES });
  };
};

export const resetTimesheet = () => {
  return (dispatch) => {
    dispatch({ type: RESET_TIMESHEET });
  };
};

export const getTimesheetEntries = (timesheetId) => {
  return (dispatch, getState) => {
    dispatch(showTimesheetLoader(true));

    // const timesheet = getState().timesheets.timesheet;
    // console.log(timesheet);
    // if (Object.keys(timesheet).length > 0) {
    //   return '';
    // }

    client()
      .get("time-entries/list", {
        params: {
          timesheet_id: timesheetId,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const data = result.data;
          const keys = Object.keys(data).length - 1;
          //determine the rows to display
          let week_num = "";
          let timesheet_id = "";
          let request_number = "";
          let start_date = "";
          let end_date = "";
          let requestor = "";
          let status = "";
          let remarks = "";

          let lastRowID = 0;

          let rows = [];

          for (var i = 0; i < keys; i++) {
            const timeEntry = data[i];

            if (!rows.includes(timeEntry.entry_row_id)) {
              rows.push(timeEntry.entry_row_id);
            }

            if (typeof timeEntry.timesheet_details !== "undefined") {
              const timesheetDetails = timeEntry.timesheet_details;

              timesheet_id = timesheetDetails.timesheet_id;
              week_num = timesheetDetails.week_number;
              request_number = timesheetDetails.request_number;
              start_date = timesheetDetails.start_date;
              end_date = timesheetDetails.end_date;
              requestor = timesheetDetails.requestor_details;
              status = timesheetDetails.status;
              remarks = timesheetDetails.remarks;
            }
          }

          //get the entries and group it based on each row/s
          let timeEntryRows = [];
          if (rows.length > 0) {
            rows.forEach((timeEntryRow) => {
              let timeEntries = [];
              let project = {};
              let project_id = "";
              let task_id = "";
              let entry_id = "";

              for (var i = 0; i < keys; i++) {
                const timeEntry = data[i];
                if (timeEntry.entry_row_id === timeEntryRow) {
                  project = timeEntry.project_details;
                  project_id = timeEntry.project_id;
                  task_id = timeEntry.task_id;
                  entry_id = timeEntry.entry_row_id;

                  timeEntries.push({
                    date: timeEntry.time_entry_date,
                    duration: timeEntry.duration,
                    entry_id: timeEntryRow,
                    time_entry_id: timeEntry.id,
                    remarks: timeEntry.remarks,
                    overtime_hours: timeEntry.overtime_hours,
                  });
                }
              }

              timeEntryRows.push({
                project: project,
                project_id: project_id,
                entries: timeEntries,
                entry_id,
                task_id,
              });

              if (entry_id > lastRowID) {
                lastRowID = entry_id;
              }
            });
          }

          //select week
          dispatch(selectWeek(start_date));

          if (timeEntryRows.length > 0) {
            dispatch({ type: SET_ROW_NUM, numRows: lastRowID });

            let timeEntriesDetails = [];
            let overTimeEntries = [];
            timeEntryRows.forEach((timeEntryRow) => {
              //insert each available entries in duration state
              const entries = timeEntryRow.entries;
              if (entries.length > 0) {
                entries.forEach((entry) => {
                  dispatch({ type: ADD_TIMESHEET_ENTRY_DATE, entry });
                  //set up overtime entries state
                  if (entry.overtime_hours > 0) {
                    const overtimeEntry = {
                      entryDate: entry.date,
                      entryId: entry.entry_id,
                      isTag: true,
                      otHours: entry.overtime_hours,
                      showPopover: false,
                      isUnTagging: false,
                    };
                    overTimeEntries.push(overtimeEntry);
                  }
                });
              }

              const timesheetRow = {
                entry_id: timeEntryRow.entry_id,
                project: timeEntryRow.project,
                project_id: timeEntryRow.project_id,
                task_id: timeEntryRow.task_id,
              };
              timeEntriesDetails.push(timesheetRow);
            });
            dispatch({
              type: UPDATE_TIMESHEET_ENTRIES,
              timesheetEntries: timeEntriesDetails,
            });
            dispatch(setOvertimeEntries(overTimeEntries));
          }

          //update the timesheet state to add details
          const timesheetDetails = {
            timesheet_id,
            status,
            week_num,
            start_date,
            end_date,
            requestor,
            request_number,
            remarks,
          };
          dispatch(showTimesheetLoader(false));
          dispatch({ type: SET_TIMESHEET, timesheet: timesheetDetails });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const resetTimesheetDates = () => {
  return (dispatch) => {
    dispatch({ type: RESET_TIMESHEET_ENTRIES });
  };
};

export const deleteTimeEntryByRow = (callback = null) => {
  return (dispatch, getState) => {
    const entryIdsToDelete = getState().timesheets.entryIdsToDelete;
    const timesheet = getState().timesheets.timesheet;
    let i = 1;
    entryIdsToDelete.length > 0 &&
      entryIdsToDelete.forEach((entryId) => {
        client()
          .get("time-entries/delete", {
            params: {
              entry_row_id: entryId,
              timesheet_id: timesheet.timesheet_id,
            },
          })
          .then((json) => {})
          .catch((error) => {
            dispatch(displayError(error));
          });

        if (++i >= entryIdsToDelete.length) {
          if (callback) {
            dispatch({ type: CLEAR_ENTRY_TO_DELETE });
            callback();
          }
        }
      });
  };
};

export const deleteRow = (entryId) => {
  return (dispatch, getState) => {
    let lastRowID = 0;
    const timesheetEntries = getState().timesheets.timesheetEntries;

    const newTimesheetEntries = timesheetEntries
      .filter((data) => {
        if (data.entry_id !== entryId) {
          if (data.entry_id > lastRowID) {
            lastRowID = data.entry_id;
          }
          return data;
        }
        return null;
      })
      .map((timesheetEntry) => {
        return timesheetEntry;
      });

    dispatch({
      type: UPDATE_TIMESHEET_ENTRIES,
      timesheetEntries: newTimesheetEntries,
    });

    const durationEntries = getState().timesheets.durationEntries;

    const newDurationEntries = durationEntries
      .filter((data) => {
        if (data.entry_id !== entryId) {
          return data;
        }
        return null;
      })
      .map((timesheetDuration) => {
        return timesheetDuration;
      });

    dispatch({
      type: UPDATE_TIMESHEET_DURATIONS,
      newDurations: newDurationEntries,
    });
    // dispatch({ type: SET_ROW_NUM, rowNum: lastRowID });

    dispatch({ type: ADD_ENTRY_TO_DELETE, entryId });
  };
};
export const deleteAdditionalRow = (entryId) => {
  return (dispatch, getState) => {
    let lastRowID = 0;
    const timesheetEntries = getState().timesheets.additionalTimeEntries;

    const newTimesheetEntries = timesheetEntries
      .filter((data) => {
        if (data.entry_id !== entryId) {
          if (data.entry_id > lastRowID) {
            lastRowID = data.entry_id;
          }
          return data;
        }
        return null;
      })
      .map((timesheetEntry) => {
        return timesheetEntry;
      });

    dispatch({
      type: UPDATE_ADDITIONAL_TIMESHEET_ENTRIES,
      additionalTimeEntries: newTimesheetEntries,
    });

    const durationEntries = getState().timesheets.durationEntries;

    const newDurationEntries = durationEntries
      .filter((data) => {
        if (data.entry_id !== entryId) {
          return data;
        }
        return null;
      })
      .map((timesheetDuration) => {
        return timesheetDuration;
      });

    dispatch({
      type: UPDATE_TIMESHEET_DURATIONS,
      newDurations: newDurationEntries,
    });
    dispatch({ type: ADD_ENTRY_TO_DELETE, entryId });
  };
};

export const fetchTotalHoursInMonth = (monthYear) => {
  return (dispatch, getState) => {
    const monthlyEntries = getState().timesheets.monthlyEntries;
    const userId = Cache.getItem("userId");
    if (!monthlyEntries) {
      return "";
    }

    if (monthlyEntries.length > 0) {
      return "";
    }

    client()
      .get("time-entries/total-hours-per-month", {
        params: {
          time_entry_date: monthYear,
          user_id: userId,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let monthlyEntries = result.data;
          if (monthlyEntries.length === 0) {
            monthlyEntries = null;
          }

          dispatch({ type: SET_MONTHLY_ENTRIES, monthlyEntries });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const resetMonthlyEntries = () => {
  return (dispatch) => {
    dispatch({ type: RESET_MONTHLY_ENTRIES });
  };
};

export const getEntriesByProjectId = (projectId) => {
  return (dispatch) => {
    client()
      .get("time-entries/get/byProjectId", {
        params: {
          project_id: projectId,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const newEntries = result.data;
          dispatch({ type: GET_ENTRIES_BY_PROJECT_ID, projectId, newEntries });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const addOvertimeEntries = (
  entryDate,
  entryId,
  hideOTPopoverOnLoad = false,
  otHours = 0,
  tagOT = false
) => {
  return (dispatch, getState) => {
    const overTimeEntries = getState().timesheets.overTimeEntries;

    let isExists = false;
    let showPopover = true;
    if (hideOTPopoverOnLoad) {
      showPopover = false;
    }

    overTimeEntries.forEach((otEntry) => {
      if (otEntry.entryDate === entryDate && otEntry.entryId === entryId) {
        isExists = true;
      }
    });

    if (!isExists) {
      dispatch({
        type: ADD_OVERTIME_ENTRIES,
        entryId,
        entryDate,
        show: showPopover,
        otHours: otHours,
        isTag: tagOT,
        isUnTagging: false,
      });
    }
  };
};

export const setOvertimeEntries = (overTimeEntries) => {
  return (dispatch) => {
    dispatch({ type: SET_OVERTIME_ENTRIES, overTimeEntries });
  };
};

/**
 * Fetches the time entries under the project
 * @param {*} projectId
 * @param {*} startDate
 * @param {*} endDate
 * @returns
 */
export const fetchTimeEntriesPerProject = (
  projectId,
  startDate = null,
  endDate = null
) => {
  return (dispatch) => {
    client()
      .get("time-entries/list/per-filter", {
        params: {
          filters: {
            project_id: projectId,
          },
          start_date: startDate,
          end_date: endDate,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let timeEntries = result.data;

          dispatch({ type: GET_APPROVED_TIME_ENTRIES, timeEntries });

          if (timeEntries.length) {
            [1, 2, 3, 4].forEach((group) => {
              let manHoursA = [];
              let manHoursB = [];
              let manHoursC = [];
              let manHoursD = [];
              let manHoursE = [];

              timeEntries
                .filter((data) => {
                  const timesheetDetails = data.timesheet_details;

                  if (
                    !timesheetDetails ||
                    !Object.keys(timesheetDetails).length
                  ) {
                    return null;
                  }

                  const requestorDetails = timesheetDetails.requestor_details;

                  if (
                    !requestorDetails ||
                    !Object.keys(requestorDetails).length
                  ) {
                    return null;
                  }

                  const userGroup = requestorDetails.group;

                  if (!userGroup || !Object.keys(userGroup).length) {
                    return null;
                  }

                  if (
                    userGroup.id === group &&
                    timesheetDetails.status === APPROVED
                  ) {
                    return data;
                  }

                  return false;
                })
                .forEach((timeEntry) => {
                  const userBand =
                    timeEntry.timesheet_details.requestor_details.band;
                  const bandName = userBand.band_name;

                  if (bandName) {
                    const bandGroup = bandName.charAt(0);

                    switch (bandGroup) {
                      case "A":
                        manHoursA.push(timeEntry.duration);
                        break;
                      case "B":
                        manHoursB.push(timeEntry.duration);
                        break;
                      case "C":
                        manHoursC.push(timeEntry.duration);
                        break;
                      case "D":
                        manHoursD.push(timeEntry.duration);
                        break;
                      case "E":
                        manHoursE.push(timeEntry.duration);
                        break;
                      default:
                        break;
                    }
                  }
                });

              dispatch({
                type: GET_TIME_ENTRIES_PER_PROJECT,
                timeEntries: {
                  group,
                  project: projectId,
                  bandA: manHoursA.reduce(sumOfEntries, 0),
                  bandB: manHoursB.reduce(sumOfEntries, 0),
                  bandC: manHoursC.reduce(sumOfEntries, 0),
                  bandD: manHoursD.reduce(sumOfEntries, 0),
                  bandE: manHoursE.reduce(sumOfEntries, 0),
                },
              });
            });
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

const sumOfEntries = (a, b) => a + b;

export const resetTimeEntriesPerProject = () => {
  return (dispatch) => {
    dispatch({ type: RESET_TIME_ENTRIES_PER_PROJECT });
  };
};

export const clearApprovedTimeEntries = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_APPROVED_TIME_ENTRIES });
  };
};
